<template>
  <!-- 菜单 -->
  <el-menu
    class="header-menu"
    :active-text-color="menuIndex === 'Main' ? '#ffffff' : '#5278EE'"
    mode="horizontal"
    :text-color="menuIndex === 'Main' ? '#ffffff' : '#5278EE'"
    :background-color="menuIndex === 'Main' ? '#4F8DFE' : ''"
    :default-active="$route.name"
    :router="true"
    @select="selectMenu"
  >
    <div v-for="(item, index) in routesList" :key="index" class="menu-item">
      <el-menu-item class="menu-item" v-if="!item.children" :route="item" :index="item.name">{{ item.meta.name }}</el-menu-item>
      <el-submenu v-else :index="item.name">
        <template slot="title">{{ item.meta.name }}</template>
        <div v-for="ele in item.children" :key="ele.name">
          <el-menu-item v-if="ele.meta.isMenu" :route="ele" :index="ele.name">
            {{ ele.meta.name }}
          </el-menu-item>
        </div>
      </el-submenu>
    </div>
  </el-menu>
</template>

<script>
import routes from '@/router'
export default {
  name: 'Menu',
  data() {
    return {
      routesList: null,
      menuIndex: 'Main'
    }
  },
  created() {
    this.routesList = routes.options.routes[1].children.filter(item => {
      if (item.meta) {
        return item.meta.isMenu
      }
    })
    // console.log(this.routesList)
  },
  methods: {
    selectMenu(index) {
      this.menuIndex = index
      this.$emit('select', index)
    }
  }
}
</script>
<style lang="scss" scoped>
.header-menu {
  display: flex;
  background: transparent;
  font-size: 16px;
  border: 0;
  @media screen and (max-width: 414px) {
    display: none;
  }
  .menu-item {
    margin: 0 6px;
    .el-menu-item,
    .el-submenu__title {
      padding: 0 10px;
    }
  }
  .el-menu-item:hover {
    background-color: none;
  }
  .el-menu-item.is-active {
    border-bottom: 2px solid !important;
  }
  .el-submenu.is-active {
    border-bottom: 2px solid #5278ee !important;
  }
}
</style>
